import { useEffect, useState } from 'react';
import { allowScroll, changeDelivaryType, changePrice, changeSaleStatusData, preventScroll } from '../../common/utils';
import noimage from '../../../img/noimage.png';
import { motion } from 'framer-motion';
import HubImagePreviewModal from './HubImagePreviewModal';
import axios from 'axios';
import resetIcon from '../../../img/resetIcon.png';

function HubDetailSlideModal(props) {
	const [HubDetailSlideData, setHubDetailSlideData] = useState({});
	const [IsOptipnOpen, setIsOptipnOpen] = useState(false);
	// const [SelectedOption, setSelectedOption] = useState('');
	const [MainImage, setMainImage] = useState('');
	const [UpdateName, setUpdateName] = useState('');
	const [UpdateRetailPrice, setUpdateRetailPrice] = useState('');
	const [UpdateRecommendedRetailPrice, setUpdateRecommendedRetailPrice] = useState('');
	const [UpdateKeyword, setUpdateKeyword] = useState('');
	const [UpdateDetailContent, setUpdateDetailContent] = useState('');
	const [IsImagePreviewModalOpen, setIsImagePreviewModalOpen] = useState(false);

	const handleMainImage = (e, img) => {
		const newMainImage = img;
		setMainImage(newMainImage);
	};
	const changeAttributes = (arr, type) => {
		if (!arr) return '-';

		function handleAttr(typeName) {
			if (type === typeName) {
				let result = arr.filter((el) => el.attrType === typeName).map((el) => el.attrValue);
				return result[0];
			}
		}
		return handleAttr(type);
	};
	const handleBlurContainer = (e) => {
		e.preventDefault();
		setTimeout(() => {
			setIsOptipnOpen(false);
		}, 200);
	};
	const handleOptionOpen = () => {
		setIsOptipnOpen(!IsOptipnOpen);
	};
	// const handleOption = (e, value) => {
	// 	const newValue = value;
	// 	if (SelectedOption !== newValue) {
	// 		setSelectedOption(newValue);
	// 		return;
	// 	}
	// };
	const handleInputChange = (e, type) => {
		e.preventDefault();
		let newValue = e.target.value;

		if (type === 'UpdateName') {
			setUpdateName(newValue);
		} else if (type === 'UpdateRetailPrice ') {
			setUpdateRetailPrice(newValue.replace(/[^0-9]/g, ''));
		} else if (type === 'UpdateRecommendedRetailPrice') {
			setUpdateRecommendedRetailPrice(newValue.replace(/[^0-9]/g, ''));
		} else if (type === 'UpdateKeyword') {
			setUpdateKeyword(newValue);
		} else if (type === 'UpdateDetailContent') {
			setUpdateDetailContent(newValue);
		}
	};
	const updateProduct = (config) => {
		axios({
			method: 'POST',
			url: `${window.location.protocol}//${window.location.hostname}:3001/updateProduct`,
			data: {
				token: localStorage.getItem('token'),
				config,
			},
			xhrFields: {
				withCredentials: true,
			},
		})
			.then((res) => {
				console.log('updateProduct response: ', res);
				// 테이블 표시되는 상태 실시간 변동 요망
				if (config.type === 'keywords') {
					setHubDetailSlideData({
						...HubDetailSlideData,
						[config.type]: config.value,
					});
				} else {
					setHubDetailSlideData({
						...HubDetailSlideData,
						information: {
							...HubDetailSlideData.information,
							[config.type]: config.value,
						},
					});
				}
			})
			.catch((error) => { });
	};
	const handleUpdateData = (e, type) => {
		e.preventDefault();
		if (type === 'UpdateName') {
			/* eslint-disable no-restricted-globals */
			const isOk = confirm('상품명을 수정하시겠습니까?');
			/* eslint-enable no-restricted-globals */
			if (isOk) {
				console.log(`상품명 수정 요청`, UpdateName);
				updateProduct({
					productNos: [props.data.productNo],
					type: 'name',
					value: UpdateName,
				});
			}
		} else if (type === 'UpdateRetailPrice ') {
			/* eslint-disable no-restricted-globals */
			const isOk = confirm('상품 소매가격를 수정하시겠습니까?');
			/* eslint-enable no-restricted-globals */
			if (isOk) {
				console.log(`상품 소매가격 수정 요청`, UpdateRetailPrice);
				updateProduct({
					productNos: [props.data.productNo],
					type: 'retailPrice',
					value: UpdateRetailPrice,
				});
			}
		} else if (type === 'UpdateRecommendedRetailPrice') {
			/* eslint-disable no-restricted-globals */
			const isOk = confirm('상품 소비자가를 수정하시겠습니까?');
			/* eslint-enable no-restricted-globals */
			if (isOk) {
				console.log(`상품 소비자가 수정 요청`, UpdateRecommendedRetailPrice);
				updateProduct({
					productNos: [props.data.productNo],
					type: 'recommendedRetailPrice',
					value: UpdateRecommendedRetailPrice,
				});
			}
		} else if (type === 'UpdateKeyword') {
			/* eslint-disable no-restricted-globals */
			const isOk = confirm('키워드를 수정하시겠습니까?');
			/* eslint-enable no-restricted-globals */
			if (isOk) {
				console.log(`키워드 수정 요청`, UpdateKeyword);
				updateProduct({
					productNos: [props.data.productNo],
					type: 'keyword',
					value: UpdateKeyword.split(',').map((m) => m.trim()),
				});
			}
		} else if (type === 'UpdateDetailContent') {
			/* eslint-disable no-restricted-globals */
			const isOk = confirm('상세이미지를 수정하시겠습니까?');
			/* eslint-enable no-restricted-globals */
			if (isOk) {
				console.log(`상세이미지 수정 요청`, UpdateDetailContent);
				updateProduct({
					productNos: [props.data.productNo],
					type: 'detailContent',
					value: UpdateDetailContent,
				});
			}
		}
	};
	const handleModCancel = (e, type, originValue) => {
		/* eslint-disable no-restricted-globals */
		const isOk = confirm(`${type}을 원본데이터 '${originValue}' 으로 초기화 하시겠습니까?`);
		/* eslint-enable no-restricted-globals */
		if (isOk) {
			let newValue = originValue;

			if (type === 'UpdateName') {
				setUpdateName(newValue);
			} else if (type === 'UpdateRetailPrice ') {
				setUpdateRetailPrice(newValue.replace(/[^0-9]/g, ''));
			} else if (type === 'UpdateRecommendedRetailPrice') {
				setUpdateRecommendedRetailPrice(newValue.replace(/[^0-9]/g, ''));
			} else if (type === 'UpdateKeyword') {
				setUpdateKeyword(newValue);
			} else if (type === 'UpdateDetailContent') {
				setUpdateDetailContent(newValue);
			}
			handleUpdateData(e, type);
		}
	};
	const handleModReset = () => {
		const modalData = { ...props.data };
		/* eslint-disable no-restricted-globals */
		const isOk = confirm(
			`모든 수정데이터를 삭제하고 원본데이터로 초기화하시겠습니까?\n\n상품명 : ${modalData.information.name}\n\n소매가격 : ${modalData.information.retailPrice}\n\n소비자가 : ${modalData.information.recommendedRetailPrice}\n\n상세이미지 : ${modalData.information.detailContent}`
		);
		/* eslint-enable no-restricted-globals */
		if (isOk) {
			delete modalData.modInformation;
			//TODO:: 수정데이터 삭제하는 API
			console.log(modalData);
		}
	};
	useEffect(() => {
		const modalData = props.data;
		if (modalData.information && modalData.information.length !== 0) {
			setUpdateName(modalData.information.name);
			setUpdateRetailPrice(modalData.information.retailPrice);
			setUpdateRecommendedRetailPrice(modalData.information.recommendedRetailPrice);
			setUpdateDetailContent(modalData.information.detailContent);
			const newMainImage =
				!!modalData.information?.images &&
					!!modalData.information?.images?.filter((f) => f.imageType === 'REPRESENTATIVE').length
					? modalData.information?.images?.filter((f) => f.imageType === 'REPRESENTATIVE')[0].imageUrl
					: noimage;
			setMainImage(newMainImage);
		}

		if (!!Object.values(modalData.modInformation).filter(f => f).length) {
			if (modalData.modInformation.name) setUpdateName(modalData.modInformation.name);
			if (modalData.modInformation.retailPrice) setUpdateRetailPrice(modalData.modInformation.retailPrice);
			if (modalData.modInformation.recommendedRetailPrice) setUpdateRecommendedRetailPrice(modalData.modInformation.recommendedRetailPrice);
			if (modalData.modInformation.detailContent) setUpdateDetailContent(modalData.modInformation.detailContent);
		}

		setUpdateKeyword(modalData.keywords || []);
		setHubDetailSlideData(modalData);
		const prevScrollY = preventScroll();
		return () => {
			allowScroll(prevScrollY);
		};
	}, [props.data]);

	useEffect(() => {
		//TODO :: 수정 후 현재 HubDetailSlideData가 업데이트 되는지 확인용. 확인 후 삭제 예정.
		console.log(HubDetailSlideData);
	}, [HubDetailSlideData]);

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1, transition: { duration: 0.2 } }}
			exit={{ opacity: 0, transition: { delay: 0.1, duration: 0.1 } }}
		>
			<div className='slide-modal'>
				<div className='slide-overlay' onClick={(e) => props.getHubDetailSlideModalOpen(false)}></div>
				<motion.div
					initial={{ x: 100 }}
					animate={{ x: 0, transition: { duration: 0.3 } }}
					exit={{ x: 100, transition: { duration: 0.2 } }}
				>
					<div className='slide-modal-content'>
						<div className='modal-header'>
							<h2>
								{HubDetailSlideData.vendorCode}_{HubDetailSlideData.commodityCode}
							</h2>
							<p>(도매사_상품코드)</p>
						</div>
						<button className='close-modal' onClick={() => props.getHubDetailSlideModalOpen(false)}></button>
						<div className='modal-body'>
							<div className='detailModalInfo'>
								<div className='imgInfo'>
									<ul className='imgList'>
										{HubDetailSlideData.information?.images?.map((f, index) => {
											return (
												<li key={index} onMouseEnter={(e) => handleMainImage(e, f.imageUrl)}>
													<img src={f.imageUrl} alt='mainImage' />
												</li>
											);
										})}
									</ul>
									<div className='img'>
										<img src={MainImage} alt='mainImage' />
									</div>
								</div>
								<div className='info'>
									<div className='modal-row'>
										<div className='modal-column'>
											<span className='key'>상품명</span>
											{/* mod관련 작업 끝나면 아래 조건수정필요 */}
											{!HubDetailSlideData.modInformation && (
												<button className='modResetButton' onClick={handleModReset}>
													초기화
												</button>
											)}
											<span className='value'>
												<input
													type='text'
													value={UpdateName || ''}
													onChange={(e) => handleInputChange(e, 'UpdateName')}
												/>
												{/* mod관련 작업 끝나면 아래 조건수정필요 */}
												{!HubDetailSlideData.modInformation && (
													<button
														className='reset'
														type='reset'
														onClick={(e) => handleModCancel(e, 'UPdateName', HubDetailSlideData.information?.name)}
													>
														<span>
															<img src={resetIcon} alt='resetIcon' />
														</span>
														{/* <a href="https://www.flaticon.com/kr/free-icons/" title=" 아이콘" > 아이콘  제작자: Taufik - Flaticon</a> */}
													</button>
												)}
												<button
													onClick={(e) => handleUpdateData(e, 'UpdateName')}
													disabled={HubDetailSlideData.information?.name === UpdateName}
												>
													수정
												</button>
											</span>
										</div>
									</div>
									<div className='modal-row'>
										<div className='modal-column'>
											<span className='key'>도매가격</span>
											<span className='value'>
												{changePrice(HubDetailSlideData.information?.wholesalePrice) ?? '-'}
											</span>
										</div>
										<div className='modal-column'>
											<span className='key'>소매가격</span>
											<span className='value'>
												<input
													type='text'
													value={UpdateRetailPrice || ''}
													onChange={(e) => handleInputChange(e, 'UpdateRetailPrice ')}
													placeholder='-'
													onBlur={(e) => {
														e.target.value = Number(e.target.value) === 0 ? '' : e.target.value;
													}}
												/>
												{/* mod관련 작업 끝나면 아래 조건수정필요 */}
												{!HubDetailSlideData.modInformation && (
													<button
														className='reset'
														type='reset'
														onClick={(e) =>
															handleModCancel(e, 'UpdateRetailPrice', HubDetailSlideData.information?.retailPrice)
														}
													>
														<span>
															<img src={resetIcon} alt='resetIcon' />
														</span>
														{/* <a href="https://www.flaticon.com/kr/free-icons/" title=" 아이콘" > 아이콘  제작자: Taufik - Flaticon</a> */}
													</button>
												)}
												<button
													onClick={(e) => handleUpdateData(e, 'UpdateRetailPrice ')}
													disabled={HubDetailSlideData.information?.retailPrice == UpdateRetailPrice}
												>
													수정
												</button>
											</span>
										</div>
									</div>
									<div className='modal-row'>
										<div className='modal-column'>
											<span className='key'>소비자준수가</span>
											<span className='value'>
												<input
													type='text'
													value={UpdateRecommendedRetailPrice || ''}
													onChange={(e) => handleInputChange(e, 'UpdateRecommendedRetailPrice')}
													placeholder='-'
													onBlur={(e) => {
														e.target.value = Number(e.target.value) === 0 ? '' : e.target.value;
													}}
												/>
												{/* mod관련 작업 끝나면 아래 조건수정필요 */}
												{!HubDetailSlideData.modInformation && (
													<button
														className='reset'
														type='reset'
														onClick={(e) =>
															handleModCancel(
																e,
																'UpdateRecommendedRetailPrice',
																HubDetailSlideData.information?.recommendedRetailPrice || ''
															)
														}
													>
														<span>
															<img src={resetIcon} alt='resetIcon' />
														</span>
														{/* <a href="https://www.flaticon.com/kr/free-icons/" title=" 아이콘" > 아이콘  제작자: Taufik - Flaticon</a> */}
													</button>
												)}
												<button
													onClick={(e) => handleUpdateData(e, 'UpdateRecommendedRetailPrice')}
													disabled={
														HubDetailSlideData.information?.recommendedRetailPrice !== null &&
														HubDetailSlideData.information?.recommendedRetailPrice == UpdateRecommendedRetailPrice
													}
												>
													수정
												</button>
											</span>
										</div>
										<div className='modal-column'>
											<span className='key'>배송비</span>
											<span className='value values'>
												<span>{changeDelivaryType(HubDetailSlideData.information?.deliveryType) ?? '-'}</span>
												<span>{changePrice(HubDetailSlideData.information?.deliveryFee) ?? '-'}</span>
											</span>
										</div>
									</div>
									<div className='modal-row'>
										<div className='modal-column'>
											<span className='key'>과세여부</span>
											<span className='value'>
												{HubDetailSlideData.information?.taxation
													? HubDetailSlideData.information?.taxation === 1
														? '과세상품'
														: '비과세상품'
													: '-'}
											</span>
										</div>
										<div className='modal-column'>
											<span className='key'>최소구매수량</span>
											<span className='value'>{HubDetailSlideData.information?.minPurchaseQuantity ?? '-'}</span>
										</div>
									</div>
									<div className='modal-row'>
										<div className='modal-column'>
											<span className='key'>브랜드</span>
											<span className='value'>
												{changeAttributes(HubDetailSlideData.information?.attributes, '브랜드') ?? '-'}
											</span>
										</div>
										<div className='modal-column'>
											<span className='key'>제조사</span>
											<span className='value'>
												{changeAttributes(HubDetailSlideData.information?.attributes, '제조사') ?? '-'}
											</span>
										</div>
										<div className='modal-column'>
											<span className='key'>원산지</span>
											<span className='value'>
												{changeAttributes(HubDetailSlideData.information?.attributes, '원산지') ?? '-'}
											</span>
										</div>
									</div>
									{/* attribute에 타입이 있는 만큼 한줄에 한 attribute로 보여주기{HubDetailSlideData.information?.attributes.map(data=>
												<div className='modal-column' key={data.attrType}>
													<span className='key' >{data.attrType}</span>
													<span className='value'>
														{data.attrValue}
													</span>
												</div>
											)
										} */}
									<div className='modal-column'>
										<span className='key'>모델명</span>
										<span className='value'>
											{changeAttributes(HubDetailSlideData.information?.attributes, '모델명') ?? '-'}
										</span>
									</div>
									{/* TODO 받은 데이터로 Dropdownbox생성 */}
									<div className='modal-column'>
										<span className='key'>옵션</span>
										<div className='container' onBlur={(e) => handleBlurContainer(e, 'category1')}>
											<label onClick={(e) => handleOptionOpen(e)}>
												<button className='dropdown-button'>
													<span>=== {HubDetailSlideData.information?.options[0]?.title} ===</span>
													<span className='dropdown-button-arrow'>{IsOptipnOpen ? ' ▲' : ' ▼'}</span>
												</button>
											</label>
											{IsOptipnOpen && (
												<div className={IsOptipnOpen ? 'dropdown-container open' : 'dropdown-container'}>
													<ul className='dropdown-content'>
														{HubDetailSlideData.information?.options.map((el, idx) => (
															<li
																key={el.optionId}
																onClick={(e) => handleOptionOpen(e)}
																className={el.optionStatus === 'SALE' ? "" : "disabled"}
															>
																{[el.optionName1, el.optionName2, el.optionName3].filter((f) => f).join('||') +
																	(el.surcharge !== 0 ? ` (${el.surcharge > 0 ? '+' : ''}${el.surcharge})` : '')}
															</li>
														))}
													</ul>
												</div>
											)}
										</div>
									</div>
									<div className='modal-row'>
										<div className='modal-column'>
											<span className='key'>카테고리</span>
											<span className='value'>{HubDetailSlideData.category?.categoryName ?? '-'}</span>
										</div>
										<div className='modal-column'>
											<span className='key'>카테고리 코드</span>
											<span className='value'>{HubDetailSlideData.category?.categoryCode ?? '-'}</span>
										</div>
									</div>
									<div className='modal-column'>
										<span className='key'>키워드</span>
										<span className='value'>
											<input
												type='text'
												value={UpdateKeyword || ''}
												onChange={(e) => handleInputChange(e, 'UpdateKeyword')}
												placeholder=', 구분자로 복수입력 가능'
											/>
											{/* mod관련 작업 끝나면 아래 조건수정필요 */}
											{!HubDetailSlideData.modInformation && (
												<button
													className='reset'
													type='reset'
													onClick={(e) =>
														handleModCancel(e, 'UpdateKeyword', HubDetailSlideData.information?.keywords || '')
													}
												>
													<span>
														<img src={resetIcon} alt='resetIcon' />
													</span>
													{/* <a href="https://www.flaticon.com/kr/free-icons/" title=" 아이콘" > 아이콘  제작자: Taufik - Flaticon</a> */}
												</button>
											)}
											<button
												onClick={(e) => handleUpdateData(e, 'UpdateKeyword')}
												disabled={
													HubDetailSlideData.keywords &&
													HubDetailSlideData.keywords.length !== 0 &&
													HubDetailSlideData.keywords === UpdateKeyword
												}
											>
												수정
											</button>
										</span>
									</div>
									<div className='modal-row'>
										<div className='modal-column'>
											<span className='key'>상태</span>
											<span className='value'>
												<span>{changeSaleStatusData(HubDetailSlideData.status) ?? '-'}</span>
											</span>
										</div>
										<div className='modal-column'>
											<span className='key'>등록일자</span>
											<span className='value'>{HubDetailSlideData.regDate ?? '-'}</span>
										</div>
									</div>
								</div>
							</div>
							<div className='detail-content'>
								<div className='detail-content-top'>
									<p className='detail-content-title'>상세이미지</p>
									<div className='buttonBox'>
										{/* mod관련 작업 끝나면 아래 조건수정필요 */}
										{!HubDetailSlideData.modInformation && (
											<button
												className='reset'
												type='reset'
												onClick={(e) =>
													handleModCancel(e, 'UpdateDetailContent', HubDetailSlideData.information?.detailContent)
												}
											>
												<span>
													<img src={resetIcon} alt='resetIcon' />
												</span>
												{/* <a href="https://www.flaticon.com/kr/free-icons/" title=" 아이콘" > 아이콘  제작자: Taufik - Flaticon</a> */}
											</button>
										)}
										<button onClick={(e) => handleUpdateData(e, 'UpdateDetailContent')}>수정</button>
										<button onClick={(e) => setIsImagePreviewModalOpen(true)}>이미지 미리보기</button>
									</div>
								</div>
								{IsImagePreviewModalOpen && (
									<HubImagePreviewModal
										imageData={UpdateDetailContent}
										getHubImagePreviewModalOpen={() => setIsImagePreviewModalOpen(false)}
									/>
								)}
								<div className='detail-content-html'>
									<textarea value={UpdateDetailContent} onChange={(e) => handleInputChange(e, 'UpdateDetailContent')} />
								</div>
							</div>
						</div>
					</div>
				</motion.div>
			</div>
		</motion.div>
	);
}

export default HubDetailSlideModal;
